import React from 'react';
import PageMenu from './PageMenu';

function MenuAbout(props) {
  return (
    <PageMenu
      {...props}
      title="About Menu"
      items={[
        // {
        //   name: 'plans',
        //   title: 'Floor Plans',
        // },
        {
          name: 'homebuilding-process',
          title: 'Homebuilding Process',
        },
        {
          name: 'design-center',
          title: 'Design Center',
        },
        {
          name: 'energy-efficiency',
          title: 'Energy Efficiency',
        },
        {
          name: 'financing-info',
          title: 'Financing Info',
        },
        {
          name: 'about-us',
          title: 'About Us',
        },
        {
          name: 'testimonials',
          title: 'Testimonials',
        },
        // {
        //   name: 'blog',
        //   title: 'Latest News',
        // },
      ]}
    />
  );
}

export default MenuAbout;



// WEBPACK FOOTER //
// ./src/components/MenuAbout.js